(function () {
  function shuffle(arr) {
    for (var i = arr.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = arr[i];
      arr[i] = arr[j];
      arr[j] = tmp;
    }
    return arr;
  }

  function initUpsell(root) {
    var count = parseInt(root.getAttribute('data-upsell-count') || '4', 10);
    var container =
      root.querySelector('[data-cshow-track]') || root.querySelector('.cshow__grid');
    if (!container) return;

    var cards = Array.prototype.slice.call(container.querySelectorAll('.cshow-card'));
    if (cards.length <= count) return;

    shuffle(cards);
    cards.forEach(function (card, i) {
      if (i < count) {
        container.appendChild(card); // gemischte Reihenfolge ans Ende
      } else {
        card.remove();
      }
    });

    // Nach dem Umsortieren immer links beginnen
    requestAnimationFrame(function () {
      container.scrollLeft = 0;
    });
  }

  function run() {
    document.querySelectorAll('[data-upsell]').forEach(initUpsell);
  }

  if (document.readyState !== 'loading') {
    run();
  } else {
    document.addEventListener('DOMContentLoaded', run);
  }
})();
